module.exports = __webpack_public_path__ + "static/media/18.83debd57.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/18.mp3
// module id = 494
// module chunks = 0